<template>
    <div class="container-fluid">
        <ListMA colClass="col-12" headerTitle="true" titles="true" title="รายละเอียด MA" v-model:details="formMA"/>
    </div>
</template>
<script setup>
import { ref, defineAsyncComponent, watch } from 'vue'
import Swal from 'sweetalert2'
import { downloadPDF } from "@/services/generate-pdf";

const ListMA = defineAsyncComponent(() => import("@/components/theme/ma/ListMA.vue"))
</script>